import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INirlatPromotion, IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class NirlatPromotionService {
  constructor(private http: HttpClient) {}

  getAllNirlatPromotion(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/nirlat-promotion', { params });
  }

  updateNirlatPromotion(id: string, nirlatPromtionData: INirlatPromotion) {
    return this.http.put(`/v1/admin/nirlat-promotion/${id}`, nirlatPromtionData);
  }

  createNirlatPromotion(nirlatPromtionData: INirlatPromotion) {
    return this.http.post('/v1/admin/nirlat-promotion', nirlatPromtionData);
  }

  getNirlatPromotionById(id: string) {
    return this.http.get(`/v1/admin/nirlat-promotion/${id}`);
  }

  deleteNirlatPromotion(id: string) {
    return this.http.delete(`/v1/admin/nirlat-promotion/${id}`);
  }

  exportNirlatPromotion(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/nirlat-promotion/export`, filterData, options);
  }

  getAllClaimedPromotion(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '')
      .set('promotionId', filterData.promotionId ? filterData.promotionId.toString() : '')
      .set('userId', filterData.userId ? filterData.userId.toString() : '')
      .set('businessId', filterData.businessId ? filterData.businessId.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/nirlat-promotion/claimed-promotion', { params });
  }

  exportClaimedtPromotion(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '')
      .set('promotionId', filterData.promotionId ? filterData.promotionId.toString() : '')
      .set('userId', filterData.userId ? filterData.userId.toString() : '')
      .set('businessId', filterData.businessId ? filterData.businessId.toString() : '');

    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(
      `/v1/admin/nirlat-promotion/export-claimed-promotion`,
      filterData,
      options,
    );
  }
}
